// Format the season's name to separate the season word from the number of the season.
export const formatSeasonName = (seasonName: string): string => {
  const basePrefix = 'season';

  if (seasonName.toLowerCase().startsWith(basePrefix)) {
    const nextChar = seasonName.charAt(basePrefix.length);

    if (nextChar !== ' ') {
      return seasonName.slice(0, basePrefix.length) + ' ' + seasonName.slice(basePrefix.length);
    }

    return seasonName;
  }

  return seasonName;
};
